import React, { useContext, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import UserContext from '../../context/UserContext';

const Download = () => {
  const { company, filename } = useParams();
  const navigate = useNavigate();


  const {apiURL} = useContext(UserContext)
  useEffect(() => {
  const downloadFile = async () => {
      try {
        const safeCompany = encodeURIComponent(company.replace(/[^a-zA-Z0-9-_ ]/g, ''));
        const safeFilename = filename.replace(/[^a-zA-Z0-9-_.() ]/g, '');
        const apiUrl = `${apiURL}/files/download/${safeCompany}/${safeFilename}`;

        const response = await axios.get(apiUrl, {
          responseType: 'blob',
          headers: {
            'User-Agent': 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36',
            // Optional: Request attachment disposition explicitly
            'Accept': '*/*',
          },
        });

        // Fallback MIME type if server doesn't provide one
        const contentType = response.headers['content-type'] || 'application/octet-stream';
        const blob = new Blob([response.data], { type: contentType });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = safeFilename; // Ensures download regardless of file type
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        // Attempt to close the window after a delay
        setTimeout(() => {
          try {
            window.close();
            setTimeout(() => {
              navigate('/');
            }, 1000);
          } catch (err) {
            console.error('Failed to close window:', err);
            navigate('/');
          }
        }, 1000);
      } catch (err) {
        console.error('Download error:', err);
        alert('Failed to download file');
        navigate('/');
      }
    };

    downloadFile();
  }, [company, filename, navigate]);

  return <div>Downloading...</div>;
};

export default Download;